export default [
  {
    path: '/modules/Attendance/attendance',
    redirect: '/modules/Attendance/attendance/Attendance',
    name: 'AttendancePage',
    component: () =>
      import('@/views/modules/attendance/attendance/Attendance.vue'),
    meta: {
      action: 'ROLE_ATEND_CONSULTAR',
      resource: 'ACL',
      pageTitle: 'Atendimento',
      breadcrumb: [
        {
          text: 'Attendance'
        }
      ]
    },
    children: [
      {
        path: 'AttendanceProfissional',
        name: 'AttendanceProfissional',
        component: () =>
          import('@/views/modules/profissional/GridProfissional.vue'),
        meta: {
          pageTitle: 'Atendimentos',
          action: 'ROLE_PROFISSIONAL',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Módulo Profissional | Atendimentos'
            }
          ]
        }
      },
      {
        path: 'Attendance',
        name: 'Attendance',
        component: () =>
          import(
            '@/views/modules/attendance/attendance/grid/AttendanceGrid.vue'
          ),
        meta: {
          pageTitle: 'Atendimentos',
          action: 'ROLE_ATEND_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Módulo Atendimento | Atendimentos'
            }
          ]
        }
      },
      {
        path: 'agendamento',
        name: 'agendamento',
        component: () =>
          import(
            '@/views/modules/attendance/agendamento/grid/AgendamentoGrid.vue'
          ),
        meta: {
          pageTitle: 'Agendas',
          action: 'ROLE_ATEND_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Módulo Atendimento | Agendamentos - Teste'
            }
          ]
        }
      },
      {
        path: 'agendamento/edit/:id',
        name: 'agendamento/edit',
        component: () =>
          import('@/views/modules/attendance/agendamento/form/Form.vue'),
        meta: {
          pageTitle: 'editar Agendamentos',
          action: 'ROLE_ATEND_CONSULTAR',
          resource: 'ACL',
          breadcrumb: [
            {
              text: 'Módulo Atendimento | editar Agendamentos'
            }
          ]
        }
      }
    ]
  }
]
